import {
  Component,
  EventEmitter,
  Input,
  OnInit,
  SimpleChanges,
  Output,
  HostListener,
} from '@angular/core';

import { filter, Observable, Subscription, take } from 'rxjs';

import { tap } from 'rxjs/operators';

import { PopupService } from '../../../../services/popup.service';

import { AuthService } from '../../../../services/auth.service';

import { Store } from '@ngrx/store';
import { AppState } from '../../../../state/app.state';
import {
  clearHubspot,
  getHubspotCompanies,
  getHubspotCompany,
  getHubspotCompanyIndustries,
  getHubspotCompanyLifeCycleStages,
  getHubspotContact,
  getHubspotDealOwners,
  getHubspotDealPipelines,
  getHubspotDeals,
  getHubspotDealStages,
  HubspotNewCompany,
  HubspotNewContact,
  hubspotNewDeal,
  showMoreHubspotDeals,
} from '../../../../state/hubspot/hubspot.actions';
import * as CrmActions from '../../../../state/crm/crm.actions';
import * as LivespaceActions from '../../../../state/livespace/livespace.actions';
import {
  selectLivespaceContactSuccess,
  selectLivespaceContactFailure,
  selectLivespaceNewContactSuccess,
  selectLivespaceNewContactFailure,
  selectLivespaceNewCompanySuccess,
  selectLivespaceNewCompanyFailure,
  selectLivespaceLoading,
  selectLivespaceDealsSuccess,
  selectLivespaceNewDealSuccess,
  selectLivespaceNewDealFailure,
  selectLivespaceSourcesSuccess,
  selectLivespaceUsersSuccess,
  selectLivespaceProductsSuccess,
  selectLivespaceCurrentUserSuccess,
} from '../../../../state/livespace/livespace.selectors';
import { selectSaveReportLoading } from '../../../../state/crm/crm.selectors';
import {
  selectHubspotCompaniesFailure,
  selectHubspotCompaniesSuccess,
  selectHubspotCompanyFailure,
  selectHubspotCompanyIndustriesFailure,
  selectHubspotCompanyIndustriesSuccess,
  selectHubspotCompanyLifeCycleStagesFailure,
  selectHubspotCompanyLifeCycleStagesSuccess,
  selectHubspotCompanySuccess,
  selectHubspotContactFailure,
  selectHubspotContactSuccess,
  selectHubspotDealOwnersFailure,
  selectHubspotDealOwnersSuccess,
  selectHubspotDealPipelinesFailure,
  selectHubspotDealPipelinesSuccess,
  selectHubspotDealsFailure,
  selectHubspotDealsSuccess,
  selectHubspotDealStagesFailure,
  selectHubspotDealStagesSuccess,
  selectHubspotNewCompanyFailure,
  selectHubspotNewCompanySuccess,
  selectHubspotNewContactFailure,
  selectHubspotNewContactSuccess,
  selectHubspotNewDealFailure,
  selectHubspotNewDealSuccess,
  selectShowMoreHubspotDealsFailure,
  selectShowMoreHubspotDealsSuccess,
} from '../../../../state/hubspot/hubspot.selectors';
import { EventTypes } from '../../../../event-types';
import { SharedService } from '../../../../services/shared.service';
import { SearchService } from '../../../../services/search.service';
import {
  animate,
  state,
  style,
  transition,
  trigger,
} from '@angular/animations';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import * as UiActions from '../../../../state/ui/ui.actions';

@Component({
  selector: 'app-crm',
  templateUrl: './crm.component.html',
  styleUrls: ['./crm.component.scss'],
  animations: [
    trigger('colorChange', [
      state(
        'invalid',
        style({
          backgroundColor: '#c4b5fd',
        }),
      ),
      state(
        'valid',
        style({
          backgroundColor: '#8b5cf6',
        }),
      ),
      transition('invalid <=> valid', [animate('0.5s')]),
    ]),
  ],
})
export class CrmComponent implements OnInit {
  @Input() aside$: Observable<boolean>;

  @Output() dataEmitter: EventEmitter<any> = new EventEmitter();
  @Output() dataEmitter2: EventEmitter<any> = new EventEmitter();
  @Output() dataEmitter3: EventEmitter<any> = new EventEmitter();
  @Input() report: any;

  contact: any = null;
  company: any = null;
  deals: any = null;
  page_deals = 1;
  show_more_deals = true;
  isLoadedContact = false;
  isLoadedCompany = false;
  isLoadedDeals = false;
  hubspot_changes: boolean = false;
  state: any;
  added_deals: any;
  isConnectedToHubSpot: boolean = false;
  isConnectedToLivespace: boolean = false;
  activeCrmProvider: 'hubspot' | 'livespace' | null = null;
  hs_name: string = '';
  hs_mail: string = '';
  hs_phone: string = '';
  hs_brief: string = '';
  isLoadedCompanies: boolean;
  hs_companies: any;
  hs_company_name: any;
  hs_company_domain: any;
  hs_company_industry: any;
  hs_company_city: any;
  errorMessages: any;
  contactForm: FormGroup;
  companyForm: FormGroup;
  isCompaniesDropdownOpen: boolean;
  isDealPipelinesDropdownOpen: boolean;
  isDealStagesDropdownOpen: boolean;
  isDealOwnersDropdownOpen: boolean;
  contact_id: any;
  hs_company_life_cycle_stages: any;
  isCompanyLifeCycleStagesDropdownOpen: boolean;
  isCompanyIndustriesDropdownOpen: boolean;
  hs_company_phone: any;
  hs_company_state: any;
  showAside: boolean = false;
  edit: boolean = false;
  user: any;
  sidebarTabs = [
    { id: 1, name: 'ContactInformation', current: true },
    { id: 2, name: 'Company', current: false },
    { id: 3, name: 'Deals', current: false },
    { id: 4, name: 'New deal', current: false },
    { id: 5, name: 'New Contact', current: false },
    { id: 6, name: 'New Company', current: false },
  ];

  ls_phone_inputs: string[] = [];
  ls_email_inputs: string[] = [];
  ls_all_emails: string[] = [];
  ls_all_phones: string[] = [];
  ls_selected_emails: string[] = [];
  ls_selected_phones: string[] = [];
  ls_linkedin: string = '';
  ls_twitter: string = '';
  ls_facebook: string = '';
  ls_company_linkedin: string = '';
  ls_company_twitter: string = '';
  ls_company_facebook: string = '';
  ls_company_client_status: string = '';
  ls_client_status_options: { value: string; label: string }[] = [
    { value: 'potential', label: 'Potential' },
    { value: 'client', label: 'Client' },
    { value: 'lost', label: 'Lost' },
    { value: 'partner', label: 'Partner' },
  ];
  contactSocialProfiles: { label: string; value: string }[] = [];
  isEditingContact: boolean = false;
  isEditingCompany: boolean = false;
  isSubmittingContact: boolean = false;
  isSubmittingCompany: boolean = false;

  // Livespace deal form fields
  ls_deal_company_name: string = '';
  ls_deal_contact_name: string = '';
  ls_deal_source_id: string = '';
  ls_deal_source_label: string = '';
  ls_deal_sources: any[] = [];
  isLsDealSourceDropdownOpen: boolean = false;
  ls_deal_close_date: any = null;
  ls_deal_owner_id: string = '';
  ls_deal_owner_label: string = '';
  ls_deal_owners: any[] = [];
  isLsDealOwnerDropdownOpen: boolean = false;
  ls_deal_visibility: string = 'public';
  ls_deal_product_id: string = '';
  ls_deal_product_label: string = '';
  ls_deal_products: any[] = [];
  isLsDealProductDropdownOpen: boolean = false;

  hs_deal_name: string = '';
  hs_deal_amount: any = '';
  hs_deal_close_date: any = null;
  hs_deal_stages: any;
  dealstage: any = ['Select Deal Stage', 0];
  hs_deal_pipelines: any;
  hs_deal_owners: any;
  industry: any = ['Select Industry', 0];
  life_cycle_stage: any = ['Select Life Cycle Stage', 0];
  pipeline: any = ['Select Pipeline', 0];
  deal_owner: any = ['Select Owner', 0];
  hs_company: any = 'Select Company';
  createCompanyFromReport: boolean = false;
  saveReportLoading$: Observable<boolean>;

  // Id of the company whose enriched data currently prefills the HubSpot
  // "company" fields — used to detect when the active company switches.
  private activeCompanyId: any = null;

  constructor(
    private popupService: PopupService,
    private authService: AuthService,
    private store: Store<AppState>,
    private sharedService: SharedService,
    public formBuilder: FormBuilder,
    private searchService: SearchService,
  ) {}

  get f() {
    return this.contactForm.controls;
  }

  get isAlreadySavedToCrm(): boolean {
    return this.report?.crm_contact != null;
  }

  get canSaveToCrm(): boolean {
    return !this.isAlreadySavedToCrm && this.report?.id != null;
  }

  get canUpdateCrm(): boolean {
    return this.isAlreadySavedToCrm && this.report?.id != null;
  }

  ngOnInit() {
    this.saveReportLoading$ = this.store.select(selectSaveReportLoading);

    setTimeout(() => {
      this.store.dispatch(clearHubspot());
      this.added_deals = 0;
      this.contact = null;
      this.company = null;
      this.deals = null;
      this.page_deals = 1;
      this.show_more_deals = true;
      this.isLoadedContact = false;
      this.isLoadedCompany = false;
      this.isLoadedDeals = false;
      this.hs_company = ['Select Company', 0];
      this.hs_name = this.report?.name;
      this.hs_mail = this.report?.email;
      this.hs_phone = this.report?.phone;

      // Prefill the HubSpot "company" fields from the ACTIVE company (the one
      // the user switched to), not a hardcoded search_companies[0]. Kept in
      // sync when the company switches via ngOnChanges.
      this.populateCompanyFieldsFromReport();
      this.hs_company_industry = null;

      const personEnhanced = this.report?.search_person?.enhanced_data ?? null;
      if (this.report?.phone == null)
        this.hs_phone = personEnhanced?.organization?.phone;

      // Build after all phone/email resolution so the lists are complete
      this.buildLivespaceContactLists();
      const tagline = this.report?.search_person?.tagline;
      this.hs_brief = tagline ? tagline.split('.')[0] + '.' : '';

      this.initPhoneInputs();
      this.initEmailInputs();
      this.initSocialMedia();

      this.contactForm = this.formBuilder.group({
        hs_name: [this.hs_name, [Validators.maxLength(50)]],
        hs_company: [this.hs_company],
        hs_brief: [this.hs_brief, [Validators.maxLength(200)]],
      });

      this.errorMessages = {
        mail: [
          {
            type: 'required',
            message: 'Email is required',
          },
          {
            type: 'email',
            message: 'Value must be an email',
          },
        ],
        name: [
          {
            type: 'maxLength',
            message: 'Name is too long',
          },
        ],
        phone: [
          {
            type: 'maxLength',
            message: 'Phone Number is too long',
          },
        ],
        company: [
          {
            type: 'maxLength',
            message: 'Company name is too long',
          },
        ],
        brief: [
          {
            type: 'maxLength',
            message: 'Brief is too long',
          },
        ],
      };

      this.companyForm = this.formBuilder.group({
        hs_company_name: [this.hs_company_name, [Validators.required]],
        hs_company_domain: [this.hs_company_domain, [Validators.maxLength(50)]],
        hs_company_industry: [
          this.industry[0] == 'Select Industry' ? '' : this.industry,
          [Validators.maxLength(50)],
        ],
        hs_company_city: [this.hs_company_city],
        hs_company_phone: [this.hs_company_phone],
        hs_company_state: [this.hs_company_state],
        hs_company_life_cycle_stages: [
          this.life_cycle_stage[0] == 'Select Life Cycle Stage'
            ? ''
            : this.life_cycle_stage,
        ],
      });

      this.errorMessages = {
        mail: [
          {
            type: 'required',
            message: 'Email is required',
          },
          {
            type: 'email',
            message: 'Value must be an email',
          },
        ],
        name: [
          {
            type: 'maxLength',
            message: 'Name is too long',
          },
        ],
        phone: [
          {
            type: 'maxLength',
            message: 'Phone Number is too long',
          },
        ],
        company: [
          {
            type: 'maxLength',
            message: 'Company name is too long',
          },
        ],
        brief: [
          {
            type: 'maxLength',
            message: 'Brief is too long',
          },
        ],
      };

      this.authService.authUser().subscribe((user) => {
        this.user = user;
        this.isConnectedToHubSpot = this.user.has_connected_to_hubspot;
        this.isConnectedToLivespace = this.user.has_connected_to_livespace;

        // Determine active CRM provider
        if (this.isConnectedToHubSpot) {
          this.activeCrmProvider = 'hubspot';
        } else if (this.isConnectedToLivespace) {
          this.activeCrmProvider = 'livespace';
        } else {
          this.activeCrmProvider = null;
        }

        this.hubspot();
      });
    }, 500); // Added Timeout For when the tab is already selected and the page refreshes
  }

  /** The currently active company for this report (falls back to the first one). */
  private getActiveCompany(): any {
    const companies = this.report?.search_companies;
    if (!companies?.length) {
      return null;
    }
    return (
      companies.find((c: any) => c.id === this.report?.search_company_id) ??
      companies[0]
    );
  }

  /**
   * Populates the HubSpot "new company" prefill fields from the active company's
   * enriched data. Safe to call before or after the form is built — when the
   * form already exists (a mid-session switch) it patches the live values too.
   */
  private populateCompanyFieldsFromReport(): void {
    const activeCompany = this.getActiveCompany();
    const companyEnhanced = activeCompany?.enhanced_data ?? null;
    this.activeCompanyId = activeCompany?.id ?? null;

    this.hs_company_name = companyEnhanced?.name;
    this.hs_company_domain = companyEnhanced?.primary_domain;
    this.hs_company_city = companyEnhanced?.city;
    this.hs_company_phone = companyEnhanced?.phone;
    this.hs_company_state = companyEnhanced?.state;

    if (this.companyForm) {
      this.companyForm.patchValue({
        hs_company_name: this.hs_company_name,
        hs_company_domain: this.hs_company_domain,
        hs_company_city: this.hs_company_city,
        hs_company_phone: this.hs_company_phone,
        hs_company_state: this.hs_company_state,
      });
    }
  }

  /**
   * React to @Input report changing (user navigates to a different report while
   * the CRM aside is still open). We detect a real report change by comparing
   * IDs and reset all state so the new report's CRM data is fetched fresh.
   */
  ngOnChanges(changes: SimpleChanges): void {
    // When the active company changes (e.g. the user switched companies in the
    // report header), refresh the company-derived HubSpot fields so the CRM tab
    // reflects the now-active company instead of the one present at init.
    // HubSpot contact/deal data is keyed by report.id (the person) and is left
    // untouched — only the enriched-company prefill follows the switch.
    if (changes['report'] && !changes['report'].firstChange) {
      const newActiveId = this.getActiveCompany()?.id ?? null;
      if (newActiveId !== this.activeCompanyId) {
        this.populateCompanyFieldsFromReport();
      }
    }
    const reportChange = changes['report'];
    if (!reportChange || reportChange.firstChange) return;

    const previousId = reportChange.previousValue?.id;
    const currentId = reportChange.currentValue?.id;

    // Only reset when the report actually changed, not on every binding update
    if (!currentId || previousId === currentId) return;

    this.resetCrmState();
    this.authService.authUser().subscribe((user) => {
      this.user = user;
      this.isConnectedToHubSpot = this.user.has_connected_to_hubspot;
      this.isConnectedToLivespace = this.user.has_connected_to_livespace;

      if (this.isConnectedToHubSpot) {
        this.activeCrmProvider = 'hubspot';
      } else if (this.isConnectedToLivespace) {
        this.activeCrmProvider = 'livespace';
      } else {
        this.activeCrmProvider = null;
      }

      // Re-populate pre-filled form fields from the new report
      this.hs_name = this.report?.name;
      this.hs_mail = this.report?.email;
      this.hs_phone = this.report?.phone;

      const companyEnhanced =
        this.report?.search_companies?.[0]?.enhanced_data ?? null;
      this.hs_company_name = companyEnhanced?.name;
      this.hs_company_domain = companyEnhanced?.primary_domain;
      this.hs_company_city = companyEnhanced?.city;
      this.hs_company_phone = companyEnhanced?.phone;
      this.hs_company_state = companyEnhanced?.state;

      // Apply the same phone fallback as ngOnInit
      const personEnhanced = this.report?.search_person?.enhanced_data ?? null;
      if (this.report?.phone == null)
        this.hs_phone = personEnhanced?.organization?.phone;

      // Build after all phone/email resolution so the lists are complete
      this.buildLivespaceContactLists();

      if (this.contactForm) {
        this.contactForm.patchValue({
          hs_name: this.hs_name,
          hs_mail: this.hs_mail,
          hs_phone: this.hs_phone,
        });
      }

      this.initPhoneInputs();
      this.initEmailInputs();
      this.initSocialMedia();

      this.hubspot();
    });
  }

  /**
   * Collect all unique emails and phone numbers from the report and pre-select all.
   */
  private buildLivespaceContactLists(): void {
    const emails: string[] = [];

    if (this.report?.email) emails.push(this.report.email);
    const enrichedEmail = this.report?.search_person?.enhanced_data?.email;
    if (enrichedEmail && !emails.includes(enrichedEmail))
      emails.push(enrichedEmail);
    const personalEmails: any[] = this.report?.personal_emails ?? [];
    personalEmails.forEach((e: string) => {
      if (e && !emails.includes(e)) emails.push(e);
    });

    this.ls_all_emails = emails;
    this.ls_selected_emails = [...emails];

    const phones: string[] = [];
    const normalizedSet = new Set<string>(); // tracks digits-only versions to deduplicate

    const addPhone = (raw: string) => {
      if (!raw) return;
      const normalized = raw.replace(/\s+/g, '');
      if (normalizedSet.has(normalized)) return;
      normalizedSet.add(normalized);
      // Store the compact version (no spaces) for consistency
      phones.push(normalized);
    };

    if (this.hs_phone) addPhone(this.hs_phone);
    const phoneNumbers: any[] = this.report?.phone_numbers ?? [];
    phoneNumbers.forEach((p: any) => {
      const num: string =
        typeof p === 'string' ? p : p?.sanitized_number || p?.raw_number || '';
      addPhone(num);
    });

    this.ls_all_phones = phones;
    this.ls_selected_phones = [...phones];
  }

  toggleLivespaceEmail(email: string): void {
    const idx = this.ls_selected_emails.indexOf(email);
    if (idx >= 0) {
      this.ls_selected_emails.splice(idx, 1);
    } else {
      this.ls_selected_emails.push(email);
    }
  }

  toggleLivespacePhone(phone: string): void {
    const idx = this.ls_selected_phones.indexOf(phone);
    if (idx >= 0) {
      this.ls_selected_phones.splice(idx, 1);
    } else {
      this.ls_selected_phones.push(phone);
    }
  }

  isEmailSelected(email: string): boolean {
    return this.ls_selected_emails.includes(email);
  }

  isPhoneSelected(phone: string): boolean {
    return this.ls_selected_phones.includes(phone);
  }

  /**
   * Open the company form pre-filled with existing Livespace company data for editing.
   */
  editLivespaceCompany(): void {
    this.isEditingCompany = true;

    this.isEditingCompany = true;

    // Pre-fill form from existing company data
    this.companyForm.patchValue({
      hs_company_name: this.company?.name || '',
      hs_company_domain: this.company?.domain || '',
      hs_company_phone: this.company?.phone || '',
      hs_company_city: this.company?.city || '',
      hs_company_state: this.company?.state || '',
    });

    // Pre-fill social fields
    this.ls_company_linkedin = this.company?.linkedin || '';
    this.ls_company_twitter = this.company?.twitter || '';
    this.ls_company_facebook = this.company?.facebook || '';

    this.changeSidebarTab(5);
  }

  /**
   * Pre-fill company social media inputs from the report's enriched data.
   */
  prefillLivespaceCompanySocials(): void {
    const companyEnriched =
      this.report?.search_companies?.[0]?.enhanced_data ?? null;
    this.ls_company_linkedin = companyEnriched?.linkedin_url || '';
    this.ls_company_twitter = companyEnriched?.twitter_url || '';
    this.ls_company_facebook = companyEnriched?.facebook_url || '';
  }

  /**
   * Extract a URL from a note string formatted as "Label: url"
   */
  private extractUrlFromNote(note: string, label: string): string | null {
    if (!note) return null;
    const regex = new RegExp(label + ':\\s*(https?://\\S+)', 'i');
    const match = note.match(regex);
    return match ? match[1] : null;
  }

  /**
   * Extract a social URL from Livespace instant_messengers array by type.
   * Types: 5=Facebook, 6=LinkedIn, 7=Instagram, 8=GoldenLine, 9=Twitter/X, 11=www
   */
  private extractFromInstantMessengers(
    instantMessengers: any[],
    type: number,
  ): string | null {
    if (!instantMessengers || !Array.isArray(instantMessengers)) return null;
    const entry = instantMessengers.find((im: any) => im.type == type);
    return entry?.im_id || null;
  }

  private resetCrmState(): void {
    this.store.dispatch(clearHubspot());
    this.store.dispatch(LivespaceActions.clearLivespace());

    this.contact = null;
    this.company = null;
    this.deals = null;
    this.contact_id = null;
    this.page_deals = 1;
    this.show_more_deals = true;
    this.isLoadedContact = false;
    this.isLoadedCompany = false;
    this.isLoadedDeals = false;
    this.hs_company = ['Select Company', 0];
    this.createCompanyFromReport = false;
    this.isEditingContact = false;
    this.isEditingCompany = false;
    this.contactSocialProfiles = [];
    this.ls_all_emails = [];
    this.ls_all_phones = [];
    this.ls_selected_emails = [];
    this.ls_selected_phones = [];

    // Reset to the first tab (Deals)
    this.sidebarTabs.forEach((tab, i) => (tab.current = i === 0));
  }

  /**
   * Track function for ngFor to improve rendering performance
   * This reduces DOM operations when the dropdown list changes
   */
  trackById(index: number, company: any): any {
    // Use the company id (assuming company[1] is the id) or fallback to index
    return company[1] || index;
  }

  trackByIndex(index: number): number {
    return index;
  }

  addPhoneInput(): void {
    this.ls_phone_inputs.push('');
  }

  removePhoneInput(index: number): void {
    this.ls_phone_inputs.splice(index, 1);
    if (this.ls_phone_inputs.length === 0) {
      this.ls_phone_inputs.push('');
    }
  }

  addEmailInput(): void {
    this.ls_email_inputs.push('');
  }

  removeEmailInput(index: number): void {
    this.ls_email_inputs.splice(index, 1);
    if (this.ls_email_inputs.length === 0) {
      this.ls_email_inputs.push('');
    }
  }

  private initPhoneInputs(): void {
    const phones: string[] = [];
    const normalizedSet = new Set<string>();

    const addPhone = (raw: string) => {
      if (!raw) return;
      const normalized = raw.replace(/\s+/g, '');
      if (normalizedSet.has(normalized)) return;
      normalizedSet.add(normalized);
      phones.push(normalized);
    };

    if (this.report?.phone) addPhone(this.report.phone);
    if (this.report?.phone_numbers?.length) {
      this.report.phone_numbers.forEach((p: any) => {
        const num =
          typeof p === 'string'
            ? p
            : p?.sanitized_number || p?.raw_number || '';
        addPhone(num);
      });
    }
    const enhancedPhones =
      this.report?.search_person?.enhanced_data?.phone_numbers;
    if (Array.isArray(enhancedPhones)) {
      enhancedPhones.forEach((p: any) => {
        const num =
          typeof p === 'string'
            ? p
            : p?.sanitized_number || p?.raw_number || '';
        addPhone(num);
      });
    }

    this.ls_phone_inputs = phones.length > 0 ? phones : [''];
  }

  private initEmailInputs(): void {
    const emails: string[] = [];
    if (this.report?.email) emails.push(this.report.email);
    const enhanced = this.report?.search_person?.enhanced_data?.email;
    if (enhanced) {
      if (Array.isArray(enhanced)) emails.push(...enhanced);
      else emails.push(enhanced);
    }
    if (Array.isArray(this.report?.personal_emails)) {
      emails.push(...this.report.personal_emails);
    }
    const unique = [...new Set(emails)].filter((e) => e && e.trim() !== '');
    this.ls_email_inputs = unique.length > 0 ? unique : [''];
  }

  private initSocialMedia(): void {
    this.ls_linkedin = this.report?.linkedin_profile || '';
    this.ls_twitter =
      this.report?.search_person?.enhanced_data?.twitter_url || '';
    this.ls_facebook =
      this.report?.search_person?.enhanced_data?.facebook_url || '';
  }

  private extractContactSocialProfiles(contactData: any): void {
    this.contactSocialProfiles = [];
    if (!contactData) return;

    // 1. Check direct fields on the contact object
    const directFields: { key: string; label: string }[] = [
      { key: 'linkedin_url', label: 'LinkedIn' },
      { key: 'linkedin_profile', label: 'LinkedIn' },
      { key: 'facebook_url', label: 'Facebook' },
      { key: 'twitter_url', label: 'Twitter' },
      { key: 'instagram_url', label: 'Instagram' },
    ];

    for (const field of directFields) {
      const value = contactData[field.key];
      if (value && !this.contactSocialProfiles.find((p) => p.value === value)) {
        this.contactSocialProfiles.push({ label: field.label, value });
      }
    }

    // 2. Extract from report's enriched data (search_person)
    const enriched = this.report?.search_person?.enhanced_data;
    if (enriched) {
      const enrichedFields: { key: string; label: string }[] = [
        { key: 'linkedin_url', label: 'LinkedIn' },
        { key: 'facebook_url', label: 'Facebook' },
        { key: 'twitter_url', label: 'Twitter' },
        { key: 'github_url', label: 'GitHub' },
      ];
      for (const field of enrichedFields) {
        const value = enriched[field.key];
        if (
          value &&
          !this.contactSocialProfiles.find((p) => p.value === value)
        ) {
          this.contactSocialProfiles.push({ label: field.label, value });
        }
      }
    }

    // 3. Check Livespace instant_messengers array
    if (
      contactData?.instant_messengers &&
      Array.isArray(contactData.instant_messengers)
    ) {
      const imTypeMap: { [key: number]: string } = {
        5: 'Facebook',
        6: 'LinkedIn',
        7: 'Instagram',
        8: 'GoldenLine',
        9: 'Twitter',
      };
      for (const im of contactData.instant_messengers) {
        const label = imTypeMap[im.type];
        if (
          label &&
          im.im_id &&
          !this.contactSocialProfiles.find((p) => p.value === im.im_id)
        ) {
          this.contactSocialProfiles.push({ label, value: im.im_id });
        }
      }
    }

    // 4. Check Livespace dataset custom fields (if available)
    if (contactData?.dataset && contactData?.dataset_field_name) {
      const socialFields = [
        'facebook',
        'linkedin',
        'twitter',
        'instagram',
        'goldenline',
      ];
      const fieldNameMap = contactData.dataset_field_name;
      const dataset = contactData.dataset;

      for (const [uuid, fieldName] of Object.entries(fieldNameMap)) {
        if (socialFields.includes(fieldName as string) && dataset[uuid]) {
          const value = dataset[uuid] as string;
          if (!this.contactSocialProfiles.find((p) => p.value === value)) {
            this.contactSocialProfiles.push({
              label: fieldName as string,
              value,
            });
          }
        }
      }
    }

    // 4. Also check the report's linkedin_profile directly
    if (
      this.report?.linkedin_profile &&
      !this.contactSocialProfiles.find(
        (p) => p.value === this.report.linkedin_profile,
      )
    ) {
      this.contactSocialProfiles.push({
        label: 'LinkedIn',
        value: this.report.linkedin_profile,
      });
    }
  }

  // Consider adding this method to handle dropdown clicks and outside clicks
  @HostListener('document:click', ['$event'])
  onDocumentClick(event: MouseEvent): void {
    // Get references to your dropdown button and menu
    const dropdownButton = document.getElementById('companiesDropdown');
    const dropdownMenu = document.getElementById('companiesDropdownMenu');

    // Check if the click was outside both the button and menu
    if (
      this.isCompaniesDropdownOpen &&
      dropdownButton &&
      dropdownMenu &&
      !dropdownButton.contains(event.target as Node) &&
      !dropdownMenu.contains(event.target as Node)
    ) {
      // Close the dropdown
      this.isCompaniesDropdownOpen = false;
    }
  }

  selectCompany(company: any = ['No Company', 0]) {
    this.hs_company = company;
    this.isCompaniesDropdownOpen = false;
  }
  selectCreateCompanyFromReport() {
    this.changeSidebarTab(5);
    this.getHsCompanyLifeCycleStages();
    this.getHsCompanyIndustries();
    this.createCompanyFromReport = true;
    this.isCompaniesDropdownOpen = false;
  }

  selectCompanyLifeCycleStage(life_cycle_stage: string) {
    this.life_cycle_stage = life_cycle_stage;

    this.companyForm
      .get('hs_company_life_cycle_stages')
      ?.setValue(life_cycle_stage);
    this.isCompanyLifeCycleStagesDropdownOpen = false;
  }

  selectCompanyIndustry(industry: string) {
    this.industry = industry;
    this.companyForm.get('hs_company_industry')?.setValue(industry);
    this.isCompanyIndustriesDropdownOpen = false;
  }

  selectPipeline(pipeline: string) {
    this.pipeline = pipeline;
    this.getHsDealStages(this.pipeline);
    this.isDealPipelinesDropdownOpen = false;
  }

  selectOwner(owner: string) {
    this.deal_owner = owner;
    this.isDealOwnersDropdownOpen = false;
  }

  selectDealStage(deal_stage: string) {
    this.dealstage = deal_stage;
    this.isDealStagesDropdownOpen = false;
  }

  hubspot() {
    this.searchService.report().subscribe((report) => {
      this.hubspot_changes = report?.report?.hubspot_changes;
    });
    this.deals = null;

    // Only fetch CRM data if user is connected to a CRM and report has an ID
    if (this.report?.id && this.isConnectedToHubSpot) {
      this.getHubspotContact();
    } else if (this.report?.id && this.isConnectedToLivespace) {
      this.getLivespaceContact();
    } else if (!this.isConnectedToHubSpot && !this.isConnectedToLivespace) {
      // Set loaded flags to true to show the disconnected state
      this.isLoadedContact = true;
      this.isLoadedCompany = true;
      this.isLoadedDeals = true;
    }

    this.sharedService.eventEmitter.subscribe((event) => {
      if (event.type === EventTypes.RELOAD_HUBSPOT) {
        if (this.report !== undefined && this.isConnectedToHubSpot) {
          this.getHubspotContact();

          this.hubspot_changes = false;

          this.popupService.notify(
            "You've successfully refreshed the hubspot Data. ",
            'Hubspot Refresh ',
            'success',
          );
        }
      }
    });
  }

  switchCrmProvider(provider: 'hubspot' | 'livespace'): void {
    if (this.activeCrmProvider === provider) return;
    this.activeCrmProvider = provider;

    this.contact = null;
    this.company = null;
    this.deals = null;
    this.contact_id = null;
    this.isLoadedContact = false;
    this.isLoadedCompany = false;
    this.isLoadedDeals = false;
    this.contactSocialProfiles = [];
    this.sidebarTabs.forEach((tab, i) => (tab.current = i === 0));

    if (provider === 'hubspot') {
      this.getHubspotContact();
    } else {
      this.getLivespaceContact();
    }
  }

  toggleCompaniesDropdown() {
    this.isCompaniesDropdownOpen = !this.isCompaniesDropdownOpen;
  }

  toggleDealPipelinesDropdown() {
    this.isDealPipelinesDropdownOpen = !this.isDealPipelinesDropdownOpen;
  }

  toggleDealOwnersDropdown() {
    this.isDealOwnersDropdownOpen = !this.isDealOwnersDropdownOpen;
  }

  toggleDealStagesDropdown() {
    this.isDealStagesDropdownOpen = !this.isDealStagesDropdownOpen;
  }

  toggleCompanyLifeCycleStagesDropdown() {
    this.isCompanyLifeCycleStagesDropdownOpen =
      !this.isCompanyLifeCycleStagesDropdownOpen;
  }

  toggleCompanyIndustriesDropdown() {
    this.isCompanyIndustriesDropdownOpen =
      !this.isCompanyIndustriesDropdownOpen;
  }

  getHubspotContact() {
    this.store.dispatch(getHubspotContact({ search_id: this.report.id }));

    const getHubspotContactSuccess$ = this.store.select(
      selectHubspotContactSuccess,
    );
    const getHubspotContactFailure$ = this.store.select(
      selectHubspotContactFailure,
    );

    let getHubspotContactSuccessSubscription: Subscription = null;
    let getHubspotContactFailureSubscription: Subscription = null;

    getHubspotContactSuccessSubscription = getHubspotContactSuccess$
      .pipe(
        filter((data) => data.hubspot_contact !== null),
        take(1),
      )
      .subscribe({
        next: (data) => {
          if (data.hubspot_contact == 'hubspot_does_not_exist') {
            this.isLoadedContact = true;
            this.isLoadedCompany = true;
            this.isLoadedDeals = true;
            this.contact = null;
          } else {
            this.contact = data.hubspot_contact[1];
            this.contact_id = data.hubspot_contact[0];

            this.isLoadedContact = true;
            // Set the createcompnanyFromReport false to make the ui understand
            // that the logic of craeting a company without having a contact is finished.
            if (this.createCompanyFromReport)
              this.createCompanyFromReport = false;
            this.getHubspotCompany();
            this.getHubspotDeals();
          }
          if (getHubspotContactSuccessSubscription) {
            getHubspotContactSuccessSubscription.unsubscribe();
          }
        },
        error: (error) => {
          console.error('Hubspot Get Contact error:', error);

          this.isLoadedContact = true;
          if (getHubspotContactSuccessSubscription) {
            getHubspotContactSuccessSubscription.unsubscribe();
          }
        },
      });

    getHubspotContactFailureSubscription = getHubspotContactFailure$
      .pipe(
        filter((error) => error !== null),
        take(1),
      )
      .subscribe({
        next: (error) => {
          console.error('[crm.component.ts] HubSpot Contact API Failure:', {
            error,
            status: error?.status,
            message: error?.message,
            fullError: JSON.stringify(error, null, 2),
          });

          this.isLoadedContact = true;
          this.isLoadedCompany = true;
          this.isLoadedDeals = true;

          // The HubSpot token may have expired/been revoked. Re-check the connection
          // (the backend now reports it from token existence) so the UI prompts a reconnect
          // instead of leaving a broken "connected" state with no working token.
          this.authService
            .authUser()
            .pipe(take(1))
            .subscribe((user) => {
              this.isConnectedToHubSpot = !!user?.has_connected_to_hubspot;
              if (!this.isConnectedToHubSpot) {
                this.popupService.notify(
                  'Your HubSpot session has expired. Please reconnect your HubSpot account in Settings → Account.',
                  'HubSpot disconnected',
                  'error',
                );
              }
            });

          if (getHubspotContactFailureSubscription) {
            getHubspotContactFailureSubscription.unsubscribe();
          }
        },
        error: (error) => {
          console.error('Hubspot Get Contact handling error:', {
            error,
            errorDetails: error,
          });

          this.isLoadedContact = true;
          if (getHubspotContactFailureSubscription) {
            getHubspotContactFailureSubscription.unsubscribe();
          }
        },
      });
  }

  getHubspotCompany() {
    this.store.dispatch(
      getHubspotCompany({
        contact_id: this.contact_id,
        search_id: this.report.id,
      }),
    );

    const getHubspotCompanySuccess$ = this.store.select(
      selectHubspotCompanySuccess,
    );
    const getHubspotCompanyFailure$ = this.store.select(
      selectHubspotCompanyFailure,
    );

    let getHubspotCompanySuccessSubscription: Subscription = null;
    let getHubspotCompanyFailureSubscription: Subscription = null;

    getHubspotCompanySuccessSubscription = getHubspotCompanySuccess$
      .pipe(
        filter((data) => data.hubspot_company != null),
        take(1),
      )
      .subscribe({
        next: (data) => {
          this.company = data.hubspot_company;

          this.isLoadedCompany = true;

          if (getHubspotCompanySuccessSubscription) {
            getHubspotCompanySuccessSubscription.unsubscribe();
          }
        },
        error: (error) => {
          console.error('Hubspot Get Company error:', error);
          this.isLoadedCompany = true;
          if (getHubspotCompanySuccessSubscription) {
            getHubspotCompanySuccessSubscription.unsubscribe();
          }
        },
      });

    getHubspotCompanyFailureSubscription = getHubspotCompanyFailure$
      .pipe(
        filter((failure) => failure !== null),
        take(1),
      )
      .subscribe({
        next: (error) => {
          this.isLoadedCompany = true;

          if (getHubspotCompanyFailureSubscription) {
            getHubspotCompanyFailureSubscription.unsubscribe();
          }
        },
        error: (error) => {
          console.error('Hubspot Get Company error handling error:', error);
          this.isLoadedCompany = true;
          if (getHubspotCompanyFailureSubscription) {
            getHubspotCompanyFailureSubscription.unsubscribe();
          }
        },
      });
  }

  getHsCompanies() {
    this.store.dispatch(getHubspotCompanies({ search_id: this.report.id }));

    const getHubspotCompaniesSuccess$ = this.store.select(
      selectHubspotCompaniesSuccess,
    );
    const getHubspotCompaniesFailure$ = this.store.select(
      selectHubspotCompaniesFailure,
    );

    let getHubspotCompaniesSuccessSubscription: Subscription = null;
    let getHubspotCompaniesFailureSubscription: Subscription = null;

    getHubspotCompaniesSuccessSubscription = getHubspotCompaniesSuccess$
      .pipe(
        filter((data) => data.hubspot_companies != null),
        take(1),
      )
      .subscribe({
        next: (data) => {
          this.hs_companies = data.hubspot_companies;
          this.isLoadedCompanies = true;

          if (getHubspotCompaniesSuccessSubscription) {
            getHubspotCompaniesSuccessSubscription.unsubscribe();
          }
        },
        error: (error) => {
          console.error('Hubspot Get Companies error:', error);
          this.isLoadedCompany = true;
          if (getHubspotCompaniesSuccessSubscription) {
            getHubspotCompaniesSuccessSubscription.unsubscribe();
          }
        },
      });

    getHubspotCompaniesFailureSubscription = getHubspotCompaniesFailure$
      .pipe(
        filter((failure) => failure !== null),
        take(1),
      )
      .subscribe({
        next: (error) => {
          this.isLoadedCompanies = true;

          if (getHubspotCompaniesFailureSubscription) {
            getHubspotCompaniesFailureSubscription.unsubscribe();
          }
        },
        error: (error) => {
          console.error('Hubspot Get Companies error handling error:', error);
          this.isLoadedCompany = true;
          if (getHubspotCompaniesFailureSubscription) {
            getHubspotCompaniesFailureSubscription.unsubscribe();
          }
        },
      });
  }

  getHsDealOwners() {
    this.store.dispatch(getHubspotDealOwners({ search_id: this.report.id }));

    const getHubspotDealOwnersSuccess$ = this.store.select(
      selectHubspotDealOwnersSuccess,
    );
    const getHubspotDealOwnersFailure$ = this.store.select(
      selectHubspotDealOwnersFailure,
    );

    let getHubspotDealOwnersSuccessSubscription: Subscription = null;
    let getHubspotDealOwnersFailureSubscription: Subscription = null;

    getHubspotDealOwnersSuccessSubscription = getHubspotDealOwnersSuccess$
      .pipe(
        filter((data) => data.hubspot_deal_owners != null),
        take(1),
      )
      .subscribe({
        next: (data) => {
          this.hs_deal_owners = data.hubspot_deal_owners;

          if (getHubspotDealOwnersSuccessSubscription) {
            getHubspotDealOwnersSuccessSubscription.unsubscribe();
          }
        },
        error: (error) => {
          console.error('Hubspot Get Deal Owners error:', error);

          if (getHubspotDealOwnersSuccessSubscription) {
            getHubspotDealOwnersSuccessSubscription.unsubscribe();
          }
        },
      });

    getHubspotDealOwnersFailureSubscription = getHubspotDealOwnersFailure$
      .pipe(
        filter((failure) => failure !== null),
        take(1),
      )
      .subscribe({
        next: (error) => {
          if (getHubspotDealOwnersFailureSubscription) {
            getHubspotDealOwnersFailureSubscription.unsubscribe();
          }
        },
        error: (error) => {
          console.error('Hubspot Get Deal Owners error handling error:', error);

          if (getHubspotDealOwnersFailureSubscription) {
            getHubspotDealOwnersFailureSubscription.unsubscribe();
          }
        },
      });
  }

  getHsCompanyLifeCycleStages() {
    this.store.dispatch(
      getHubspotCompanyLifeCycleStages({ search_id: this.report.id }),
    );

    const getHubspotCompanyLifeCycleStagesSuccess$ = this.store.select(
      selectHubspotCompanyLifeCycleStagesSuccess,
    );
    const getHubspotCompanyLifeCycleStagesFailure$ = this.store.select(
      selectHubspotCompanyLifeCycleStagesFailure,
    );

    let getHubspotCompanyLifeCycleStagesSuccessSubscription: Subscription =
      null;
    let getHubspotCompanyLifeCycleStagesFailureSubscription: Subscription =
      null;

    getHubspotCompanyLifeCycleStagesSuccessSubscription =
      getHubspotCompanyLifeCycleStagesSuccess$
        .pipe(
          filter((data) => data.hubspot_company_life_cycle_stages != null),
          take(1),
        )
        .subscribe({
          next: (data) => {
            this.hs_company_life_cycle_stages =
              data.hubspot_company_life_cycle_stages;

            if (getHubspotCompanyLifeCycleStagesSuccessSubscription) {
              getHubspotCompanyLifeCycleStagesSuccessSubscription.unsubscribe();
            }
          },
          error: (error) => {
            console.error(
              'Hubspot Get Company Life Cycle Stages error:',
              error,
            );

            if (getHubspotCompanyLifeCycleStagesSuccessSubscription) {
              getHubspotCompanyLifeCycleStagesSuccessSubscription.unsubscribe();
            }
          },
        });

    getHubspotCompanyLifeCycleStagesFailureSubscription =
      getHubspotCompanyLifeCycleStagesFailure$
        .pipe(
          filter((failure) => failure !== null),
          take(1),
        )
        .subscribe({
          next: (error) => {
            if (getHubspotCompanyLifeCycleStagesFailureSubscription) {
              getHubspotCompanyLifeCycleStagesFailureSubscription.unsubscribe();
            }
          },
          error: (error) => {
            console.error(
              'Hubspot Get Company Life Cycle Stages error handling error:',
              error,
            );

            if (getHubspotCompanyLifeCycleStagesFailureSubscription) {
              getHubspotCompanyLifeCycleStagesFailureSubscription.unsubscribe();
            }
          },
        });
  }

  getHsCompanyIndustries() {
    this.store.dispatch(
      getHubspotCompanyIndustries({ search_id: this.report.id }),
    );

    const getHubspotCompanyIndustriesSuccess$ = this.store.select(
      selectHubspotCompanyIndustriesSuccess,
    );
    const getHubspotCompanyIndustriesFailure$ = this.store.select(
      selectHubspotCompanyIndustriesFailure,
    );

    let getHubspotCompanyIndustriesSuccessSubscription: Subscription = null;
    let getHubspotCompanyIndustriesFailureSubscription: Subscription = null;

    getHubspotCompanyIndustriesSuccessSubscription =
      getHubspotCompanyIndustriesSuccess$
        .pipe(
          filter((data) => data.hubspot_company_industries != null),
          take(1),
        )
        .subscribe({
          next: (data) => {
            this.hs_company_industry = data.hubspot_company_industries;

            if (getHubspotCompanyIndustriesSuccessSubscription) {
              getHubspotCompanyIndustriesSuccessSubscription.unsubscribe();
            }
          },
          error: (error) => {
            // Handle error
            console.error('Hubspot Get Company Industries error:', error);

            if (getHubspotCompanyIndustriesSuccessSubscription) {
              getHubspotCompanyIndustriesSuccessSubscription.unsubscribe();
            }
          },
        });

    getHubspotCompanyIndustriesFailureSubscription =
      getHubspotCompanyIndustriesFailure$
        .pipe(
          filter((failure) => failure !== null), // Filter for the failure condition, assuming failure is null when there's no error
          take(1), // Take the first occurrence
        )
        .subscribe({
          next: (error) => {
            // Handle failure

            if (getHubspotCompanyIndustriesFailureSubscription) {
              getHubspotCompanyIndustriesFailureSubscription.unsubscribe();
            }
          },
          error: (error) => {
            // Handle error in error handling
            console.error(
              'Hubspot Get Company Industries error handling error:',
              error,
            );

            if (getHubspotCompanyIndustriesFailureSubscription) {
              getHubspotCompanyIndustriesFailureSubscription.unsubscribe();
            }
          },
        });
  }

  getHsDealPipelines() {
    this.store.dispatch(getHubspotDealPipelines({ search_id: this.report.id }));

    const getHubspotDealPipelinesSuccess$ = this.store.select(
      selectHubspotDealPipelinesSuccess,
    );
    const getHubspotDealPipelinesFailure$ = this.store.select(
      selectHubspotDealPipelinesFailure,
    );

    let getHubspotDealPipelinesSuccessSubscription: Subscription = null;
    let getHubspotDealPipelinesFailureSubscription: Subscription = null;

    getHubspotDealPipelinesSuccessSubscription = getHubspotDealPipelinesSuccess$
      .pipe(
        // Trying with filter data.error === null but not working
        filter((data) => data.hubspot_deal_pipelines != null),
        take(1),
      )
      .subscribe({
        next: (data) => {
          this.hs_deal_pipelines = data.hubspot_deal_pipelines;

          if (getHubspotDealPipelinesSuccessSubscription) {
            getHubspotDealPipelinesSuccessSubscription.unsubscribe();
          }
        },
        error: (error) => {
          // Handle error
          console.error('Hubspot Get Deal Pipelines error:', error);

          if (getHubspotDealPipelinesSuccessSubscription) {
            getHubspotDealPipelinesSuccessSubscription.unsubscribe();
          }
        },
      });

    getHubspotDealPipelinesFailureSubscription = getHubspotDealPipelinesFailure$
      .pipe(
        filter((failure) => failure !== null), // Filter for the failure condition, assuming failure is null when there's no error
        take(1),
      )
      .subscribe({
        next: (error) => {
          if (getHubspotDealPipelinesFailureSubscription) {
            getHubspotDealPipelinesFailureSubscription.unsubscribe();
          }
        },
        error: (error) => {
          console.error(
            'Hubspot Get Deal Pipelines error handling error:',
            error,
          );

          if (getHubspotDealPipelinesFailureSubscription) {
            getHubspotDealPipelinesFailureSubscription.unsubscribe();
          }
        },
      });
  }

  getHsDealStages(pipeline) {
    this.store.dispatch(
      getHubspotDealStages({ search_id: this.report.id, pipeline: pipeline }),
    );

    const getHubspotDealStagesSuccess$ = this.store.select(
      selectHubspotDealStagesSuccess,
    );
    const getHubspotDealStagesFailure$ = this.store.select(
      selectHubspotDealStagesFailure,
    );

    let getHubspotDealStagesSuccessSubscription: Subscription = null;
    let getHubspotDealStagesFailureSubscription: Subscription = null;

    getHubspotDealStagesSuccessSubscription = getHubspotDealStagesSuccess$
      .pipe(
        filter((data) => data.hubspot_deal_stages != null),
        take(1),
      )
      .subscribe({
        next: (data) => {
          this.hs_deal_stages = data.hubspot_deal_stages;

          if (getHubspotDealStagesSuccessSubscription) {
            getHubspotDealStagesSuccessSubscription.unsubscribe();
          }
        },
        error: (error) => {
          console.error('Hubspot Get Deal Stages error:', error);

          if (getHubspotDealStagesSuccessSubscription) {
            getHubspotDealStagesSuccessSubscription.unsubscribe();
          }
        },
      });

    getHubspotDealStagesFailureSubscription = getHubspotDealStagesFailure$
      .pipe(
        filter((failure) => failure !== null), // Filter for the failure condition, assuming failure is null when there's no error
        take(1),
      )
      .subscribe({
        next: (error) => {
          if (getHubspotDealStagesFailureSubscription) {
            getHubspotDealStagesFailureSubscription.unsubscribe();
          }
        },
        error: (error) => {
          console.error('Hubspot Get Deal Stages error handling error:', error);

          if (getHubspotDealStagesFailureSubscription) {
            getHubspotDealStagesFailureSubscription.unsubscribe();
          }
        },
      });
  }

  newHubspotCompany() {
    if (this.companyForm.valid) {
      this.store.dispatch(
        HubspotNewCompany({
          user_id: this.user.id,
          company_name: this.companyForm.value.hs_company_name,
          company_domain: this.companyForm.value.hs_company_domain,
          company_phone: this.companyForm.value.hs_company_phone,
          company_city: this.companyForm.value.hs_company_city,
          company_state: this.companyForm.value.hs_company_state,
          company_industry: this.companyForm.value.hs_company_industry,
          company_life_cycle_stage:
            this.companyForm.value.hs_company_life_cycle_stages,
          contact_id: this.contact_id,
        }),
      );

      const HubspotNewCompanySuccess$ = this.store.select(
        selectHubspotNewCompanySuccess,
      );
      const HubspotNewCompanyFailure$ = this.store.select(
        selectHubspotNewCompanyFailure,
      );

      let HubspotNewCompanySuccessSubscription: Subscription = null;
      let HubspotNewCompanyFailureSubscription: Subscription = null;

      HubspotNewCompanySuccessSubscription = HubspotNewCompanySuccess$.pipe(
        filter((data) => data.hubspot_new_company != null),
        take(1),
      ).subscribe({
        next: (data) => {
          if (this.createCompanyFromReport) {
            this.createCompanyFromReport = false;
            this.hs_companies = this.hs_companies.concat([
              [
                data.hubspot_new_company.properties.name,
                data.hubspot_new_company.id,
              ],
            ]);
            this.hs_company = [
              data.hubspot_new_company.properties.name,
              data.hubspot_new_company.id,
            ];
            this.isCompaniesDropdownOpen = false;
            this.changeSidebarTab(4);
          } else {
            this.changeSidebarTab(1);
            this.isLoadedCompany = false;
            this.getHubspotCompany();
          }
          if (HubspotNewCompanySuccessSubscription) {
            HubspotNewCompanySuccessSubscription.unsubscribe();
          }
        },
        error: (error) => {
          console.error('Hubspot New Company error:', error);

          if (HubspotNewCompanySuccessSubscription) {
            HubspotNewCompanySuccessSubscription.unsubscribe();
          }
        },
      });

      HubspotNewCompanyFailureSubscription = HubspotNewCompanyFailure$.pipe(
        filter((failure) => failure !== null),
        take(1),
      ).subscribe({
        next: (error) => {
          if (HubspotNewCompanyFailureSubscription) {
            HubspotNewCompanyFailureSubscription.unsubscribe();
          }
        },
        error: (error) => {
          console.error('Hubspot New Company handling error:', error);

          if (HubspotNewCompanyFailureSubscription) {
            HubspotNewCompanyFailureSubscription.unsubscribe();
          }
        },
      });
    }
  }

  newHubspotContact() {
    if (this.contactForm.valid) {
      this.store.dispatch(
        HubspotNewContact({
          user_id: this.user.id,
          name: this.contactForm.value.hs_name,
          company: this.hs_company,
          mail: this.hs_mail,
          phone: this.hs_phone,
        }),
      );

      const HubspotNewContactSuccess$ = this.store.select(
        selectHubspotNewContactSuccess,
      );
      const HubspotNewContactFailure$ = this.store.select(
        selectHubspotNewContactFailure,
      );

      let HubspotNewContactSuccessSubscription: Subscription = null;
      let HubspotNewContactFailureSubscription: Subscription = null;

      HubspotNewContactSuccessSubscription = HubspotNewContactSuccess$.pipe(
        filter((data) => data.hubspot_new_contact != null),
        take(1),
      ).subscribe({
        next: (data) => {
          this.isLoadedContact = false;
          this.isLoadedCompany = false;
          this.isLoadedDeals = false;
          this.getHubspotContact();

          this.changeSidebarTab(0);

          if (HubspotNewContactSuccessSubscription) {
            HubspotNewContactSuccessSubscription.unsubscribe();
          }
        },
        error: (error) => {
          console.error('Hubspot New Contact error:', error);

          if (HubspotNewContactSuccessSubscription) {
            HubspotNewContactSuccessSubscription.unsubscribe();
          }
        },
      });

      HubspotNewContactFailureSubscription = HubspotNewContactFailure$.pipe(
        filter((failure) => failure !== null),
        take(1),
      ).subscribe({
        next: (error) => {
          if (HubspotNewContactFailureSubscription) {
            HubspotNewContactFailureSubscription.unsubscribe();
          }
        },
        error: (error) => {
          console.error('Hubspot New Contact handling error:', error);

          if (HubspotNewContactFailureSubscription) {
            HubspotNewContactFailureSubscription.unsubscribe();
          }
        },
      });
    }
  }

  getHubspotDeals() {
    this.store.dispatch(
      getHubspotDeals({
        contact_id: this.contact_id,
        search_id: this.report.id,
      }),
    );

    const getHubspotDealsSuccess$ = this.store.select(
      selectHubspotDealsSuccess,
    );
    const getHubspotDealsFailure$ = this.store.select(
      selectHubspotDealsFailure,
    );

    let getHubspotDealsSuccessSubscription: Subscription = null;
    let getHubspotDealsFailureSubscription: Subscription = null;

    getHubspotDealsSuccessSubscription = getHubspotDealsSuccess$
      .pipe(
        filter(
          (data) => data.hubspot_deals != null && data.loadingHubspot != true,
        ),
        take(1),
      )
      .subscribe({
        next: (data) => {
          this.deals = data.hubspot_deals.deals;

          if (data.hubspot_deals?.total === this.deals?.length)
            this.show_more_deals = false;

          this.isLoadedDeals = true;

          if (getHubspotDealsSuccessSubscription) {
            getHubspotDealsSuccessSubscription.unsubscribe();
          }
        },
        error: (error) => {
          // Handle error
          console.error('Hubspot Get Deals error:', error);
          this.isLoadedDeals = true;
          this.show_more_deals = false;
          if (getHubspotDealsSuccessSubscription) {
            getHubspotDealsSuccessSubscription.unsubscribe();
          }
        },
      });

    getHubspotDealsFailureSubscription = getHubspotDealsFailure$
      .pipe(
        filter((failure) => failure !== null),
        take(1),
      )
      .subscribe({
        next: (error) => {
          this.isLoadedDeals = true;
          this.show_more_deals = false;
          if (getHubspotDealsFailureSubscription) {
            getHubspotDealsFailureSubscription.unsubscribe();
          }
        },
        error: (error) => {
          console.error('Hubspot  Get Deals handling error:', error);
          this.isLoadedDeals = true;
          this.show_more_deals = false;
          if (getHubspotDealsFailureSubscription) {
            getHubspotDealsFailureSubscription.unsubscribe();
          }
        },
      });
  }

  showMoreDeals() {
    this.page_deals += 1;
    this.store.dispatch(
      showMoreHubspotDeals({
        contact_id: this.contact_id,
        search_id: this.report.id,
        page: this.page_deals,
      }),
    );

    const showMoreHubspotDealsSuccess$ = this.store.select(
      selectShowMoreHubspotDealsSuccess,
    );
    const showMoreHubspotDealsFailure$ = this.store.select(
      selectShowMoreHubspotDealsFailure,
    );

    let showMoreHubspotDealsSuccessSubscription: Subscription = null;
    let showMoreHubspotDealsFailureSubscription: Subscription = null;

    showMoreHubspotDealsSuccessSubscription = showMoreHubspotDealsSuccess$
      .pipe(
        filter((data) => data.hubspot_deals != null),
        take(1),
      )
      .subscribe({
        next: (data) => {
          this.deals = this.deals.concat(data.hubspot_deals.deals);

          // Change the total value of the pagination if user added a deal
          if (this.added_deals != 0) {
            if (
              data.hubspot_deals.total + this.added_deals ===
              this.deals.length
            )
              this.show_more_deals = false;
          } else if (data.hubspot_deals.total === this.deals.length)
            this.show_more_deals = false;

          if (showMoreHubspotDealsSuccessSubscription) {
            showMoreHubspotDealsSuccessSubscription.unsubscribe();
          }
        },
        error: (error) => {
          console.error('Hubspot Show More Deals error:', error);

          if (showMoreHubspotDealsSuccessSubscription) {
            showMoreHubspotDealsSuccessSubscription.unsubscribe();
          }
        },
      });

    showMoreHubspotDealsFailureSubscription = showMoreHubspotDealsFailure$
      .pipe(
        filter((failure) => failure !== null),
        take(1),
      )
      .subscribe({
        next: (error) => {
          if (showMoreHubspotDealsFailureSubscription) {
            showMoreHubspotDealsFailureSubscription.unsubscribe();
          }
        },
        error: (error) => {
          // Handle error in error handling
          console.error('Hubspot  Show More Deals handling error:', error);

          if (showMoreHubspotDealsFailureSubscription) {
            showMoreHubspotDealsFailureSubscription.unsubscribe();
          }
        },
      });
  }

  hideAside() {
    const aside = false;
    this.dataEmitter.emit(aside);
  }

  submitDealForm() {
    if (this.activeCrmProvider === 'livespace') {
      this.submitLivespaceDeal();
      return;
    }

    this.store.dispatch(
      hubspotNewDeal({
        user_id: this.user.id,
        properties: {
          dealname: this.hs_deal_name,
          pipeline: this.pipeline,
          dealstage: this.dealstage,
          amount: this.hs_deal_amount,
          close_date: this.hs_deal_close_date,
          dealowner: this.deal_owner,
        },
        contact_id: this.contact_id,
      }),
    );

    const hubspotNewDealSuccess$ = this.store.select(
      selectHubspotNewDealSuccess,
    );
    const hubspotNewDealFailure$ = this.store.select(
      selectHubspotNewDealFailure,
    );

    let hubspotNewDealSuccessSubscription: Subscription = null;
    let hubspotNewDealFailureSubscription: Subscription = null;

    hubspotNewDealSuccessSubscription = hubspotNewDealSuccess$
      .pipe(
        filter((data) => data.hs_object != null),
        take(1),
      )
      .subscribe({
        next: (data) => {
          this.popupService.notify(
            'You have successfully created a new deal!',
            'Success',
            'success',
          );

          this.isLoadedDeals = false;

          this.changeSidebarTab(2);

          if (this.deals == null) {
            this.deals = [data.hs_object];
          } else {
            this.deals = [data.hs_object].concat(this.deals);
          }
          this.added_deals += 1;

          setTimeout(() => {
            this.isLoadedDeals = true;
          }, 1000);

          if (hubspotNewDealSuccessSubscription) {
            hubspotNewDealSuccessSubscription.unsubscribe();
          }
        },
        error: (error) => {
          console.error('Hubspot create new deal error:', error);

          if (hubspotNewDealSuccessSubscription) {
            hubspotNewDealSuccessSubscription.unsubscribe();
          }
        },
      });

    hubspotNewDealFailureSubscription = hubspotNewDealFailure$
      .pipe(
        filter((failure) => failure !== null),
        take(1),
      )
      .subscribe({
        next: (error) => {
          const errorMessage = error.error.error.message;

          if (hubspotNewDealFailureSubscription) {
            hubspotNewDealFailureSubscription.unsubscribe();
          }
        },
        error: (error) => {
          console.error('Hubspot new deal  error handling error:', error);

          if (hubspotNewDealFailureSubscription) {
            hubspotNewDealFailureSubscription.unsubscribe();
          }
        },
      });
  }

  // ─── Livespace Deal Form Methods ─────────────────────────────────────

  /**
   * Fetch deal form metadata from Livespace (sources, users, products, current user).
   * Called when the "New Deal" tab is activated for Livespace.
   */
  loadLivespaceDealFormData(): void {
    this.store.dispatch(LivespaceActions.getLivespaceSources());
    this.store.dispatch(LivespaceActions.getLivespaceUsers());
    this.store.dispatch(LivespaceActions.getLivespaceProducts());
    this.store.dispatch(LivespaceActions.getLivespaceCurrentUser());

    // Pre-fill company/contact from existing data
    this.ls_deal_company_name = this.company?.name || '';
    this.ls_deal_contact_name = this.contact
      ? `${this.contact['firstname'] || ''} ${this.contact['lastname'] || ''}`.trim()
      : '';

    // Pre-fill closing date to 1 month from now
    const oneMonthAhead = new Date();
    oneMonthAhead.setMonth(oneMonthAhead.getMonth() + 1);
    this.ls_deal_close_date = oneMonthAhead;

    // Subscribe to sources
    // Livespace API returns: { source: [{id, name}] } or flat array
    this.store
      .select(selectLivespaceSourcesSuccess)
      .pipe(
        filter((data) => data != null),
        take(1),
      )
      .subscribe((sources) => {
        if (Array.isArray(sources)) {
          this.ls_deal_sources = sources;
        } else if (sources?.source && Array.isArray(sources.source)) {
          this.ls_deal_sources = sources.source;
        } else {
          this.ls_deal_sources = [];
        }
      });

    // Subscribe to users
    // Livespace API returns: { user: [{id, name, firstname, lastname}] } or flat array
    this.store
      .select(selectLivespaceUsersSuccess)
      .pipe(
        filter((data) => data != null),
        take(1),
      )
      .subscribe((users) => {
        if (Array.isArray(users)) {
          this.ls_deal_owners = users;
        } else if (users?.user && Array.isArray(users.user)) {
          this.ls_deal_owners = users.user;
        } else {
          this.ls_deal_owners = [];
        }
      });

    // Subscribe to products
    // Livespace API returns: { product: [{id, name, sku, default_price, ...}] }
    this.store
      .select(selectLivespaceProductsSuccess)
      .pipe(
        filter((data) => data != null),
        take(1),
      )
      .subscribe((products) => {
        if (Array.isArray(products)) {
          this.ls_deal_products = products;
        } else if (products?.product && Array.isArray(products.product)) {
          this.ls_deal_products = products.product;
        } else {
          this.ls_deal_products = [];
        }
      });

    // Subscribe to current user (auto-fill owner)
    this.store
      .select(selectLivespaceCurrentUserSuccess)
      .pipe(
        filter((data) => data != null),
        take(1),
      )
      .subscribe((currentUser) => {
        if (currentUser && currentUser.id) {
          this.ls_deal_owner_id = currentUser.id;
          this.ls_deal_owner_label =
            currentUser.name ||
            `${currentUser.firstname || ''} ${currentUser.lastname || ''}`.trim();
        }
      });
  }

  selectLsDealSource(source: any): void {
    this.ls_deal_source_id = source.id;
    this.ls_deal_source_label = source.name;
    this.isLsDealSourceDropdownOpen = false;
  }

  selectLsDealOwner(owner: any): void {
    this.ls_deal_owner_id = owner.id;
    this.ls_deal_owner_label =
      owner.name || `${owner.firstname || ''} ${owner.lastname || ''}`.trim();
    this.isLsDealOwnerDropdownOpen = false;
  }

  selectLsDealProduct(product: any): void {
    this.ls_deal_product_id = product.id;
    this.ls_deal_product_label = product.name;
    this.isLsDealProductDropdownOpen = false;
  }

  private submitLivespaceDeal(): void {
    const contactName =
      this.ls_deal_contact_name ||
      (this.contact
        ? `${this.contact['firstname'] || ''} ${this.contact['lastname'] || ''}`.trim()
        : '');
    const companyName = this.ls_deal_company_name || this.company?.name || '';

    // Format closing date
    let dateEnd: string | undefined;
    if (this.ls_deal_close_date) {
      const d = new Date(this.ls_deal_close_date);
      dateEnd = d.toISOString().split('T')[0]; // YYYY-MM-DD format
    }

    this.store.dispatch(
      LivespaceActions.livespaceNewDeal({
        user_id: this.user.id,
        deal_name: this.hs_deal_name,
        company_name: companyName,
        contact_name: contactName,
        date_end: dateEnd,
        source_id: this.ls_deal_source_id || undefined,
        owner_id: this.ls_deal_owner_id || undefined,
        visibility: this.ls_deal_visibility,
        category_name: this.ls_deal_product_label || undefined,
        product_id: this.ls_deal_product_id || undefined,
      }),
    );

    const success$ = this.store.select(selectLivespaceNewDealSuccess);
    const failure$ = this.store.select(selectLivespaceNewDealFailure);

    let successSub: Subscription = null;
    let failureSub: Subscription = null;

    successSub = success$
      .pipe(
        filter((data) => data?.livespace_new_deal != null),
        take(1),
      )
      .subscribe({
        next: (data) => {
          this.popupService.notify(
            'You have successfully created a new Livespace deal!',
            'Success',
            'success',
          );
          this.isLoadedDeals = false;
          this.changeSidebarTab(2);

          // Livespace addDeal returns: { deal: { id, name, date_end, stage_name, ... } }
          const responseData = data.livespace_new_deal;
          const deal = responseData?.deal || responseData || {};

          const newDeal = {
            dealname: deal.name || this.hs_deal_name,
            dealstage: deal.stage_name || 'new',
            date_end: deal.date_end || dateEnd,
            id: deal.id || deal.deal_id,
          };
          if (this.deals == null) {
            this.deals = [newDeal];
          } else {
            this.deals = [newDeal].concat(this.deals);
          }
          this.added_deals += 1;

          setTimeout(() => {
            this.isLoadedDeals = true;
          }, 1000);

          if (successSub) successSub.unsubscribe();
        },
        error: () => {
          if (successSub) successSub.unsubscribe();
        },
      });

    failureSub = failure$
      .pipe(
        filter((f) => f !== null),
        take(1),
      )
      .subscribe({
        next: () => {
          this.popupService.notify(
            'Failed to create a new Livespace deal.',
            'Error',
            'error',
          );
          if (failureSub) failureSub.unsubscribe();
        },
        error: () => {
          if (failureSub) failureSub.unsubscribe();
        },
      });
  }

  changeSidebarTab(tabIndex: number) {
    this.sidebarTabs.forEach((tab) => {
      tab.current = false;
    });

    this.sidebarTabs[tabIndex].current = true;

    this.dataEmitter.emit(this.sidebarTabs);

    this.toggleShowAside();
  }

  toggleShowAside() {
    this.showAside = true;
    this.dataEmitter2.emit(this.showAside);
  }

  formatStage(stage) {
    switch (stage) {
      case 'closedwon':
        stage = 'Closed Won';
        break;
      case 'appointmentscheduled':
        stage = 'Appoinment Scheduled';
        break;
      case 'contractsent':
        stage = 'Contract Sent';
        break;
      case 'closedlost':
        stage = 'Closed Lost';
        break;
      case 'decisionmakerboughtin':
        stage = 'Decision maker bought in ';
        break;
      case 'presentationscheduled':
        stage = 'Presentation Scheduled';
        break;
      case 'qualifiedtobuy':
        stage = 'Qualified to buy';
        break;
    }

    return stage;
  }

  closeAside(): void {
    this.store.dispatch(UiActions.toggleAside({ isOpen: false }));
  }

  saveToCrm(): void {
    if (this.report && this.report.id) {
      this.store.dispatch(
        CrmActions.saveReportToCrm({
          searchId: this.report.id,
          config: {
            mapping_config: {
              create_companies: true,
              create_contacts: true,
              link_contacts_to_companies: true,
              default_lead_source: 'SalesOMMO Report',
            },
          },
        }),
      );
    }
  }

  // ─── Livespace Methods ──────────────────────────────────────────────

  getLivespaceContact(): void {
    if (!this.report?.id) {
      this.isLoadedContact = true;
      this.isLoadedCompany = true;
      this.isLoadedDeals = true;
      return;
    }

    this.store.dispatch(
      LivespaceActions.getLivespaceContact({ search_id: this.report.id }),
    );

    const getLivespaceContactSuccess$ = this.store.select(
      selectLivespaceContactSuccess,
    );
    const getLivespaceContactFailure$ = this.store.select(
      selectLivespaceContactFailure,
    );

    let successSub: Subscription = null;
    let failureSub: Subscription = null;

    successSub = getLivespaceContactSuccess$
      .pipe(
        filter((data) => data.livespace_contact !== null),
        take(1),
      )
      .subscribe({
        next: (data) => {
          if (data.livespace_contact === 'livespace_does_not_exist') {
            // Contact doesn't exist in Livespace yet — show "Create" button
            this.contact = null;
            this.isLoadedContact = true;
            this.isLoadedCompany = true;
            this.isLoadedDeals = true;
          } else {
            // Contact found — display it
            const contactData =
              data.livespace_contact?.contact || data.livespace_contact;
            this.contact = contactData;
            this.contact_id = contactData?.id || contactData?.contact_id;

            // Extract social profiles from Livespace dataset
            this.extractContactSocialProfiles(contactData);

            // Extract company info strictly from Livespace data only
            const lsCompany = contactData?.company;
            const companyName = lsCompany?.name || contactData?.company_name;

            if (companyName && lsCompany) {
              // Extract social links from instant_messengers (primary) or note (fallback)
              const ims = lsCompany.instant_messengers || [];
              const linkedinFromIM = this.extractFromInstantMessengers(ims, 6);
              const facebookFromIM = this.extractFromInstantMessengers(ims, 5);
              const twitterFromIM = this.extractFromInstantMessengers(ims, 9);

              // Fallback: parse from note field (legacy data)
              const note = lsCompany.note || '';
              const linkedinFromNote = this.extractUrlFromNote(
                note,
                'LinkedIn',
              );
              const twitterFromNote = this.extractUrlFromNote(note, 'Twitter');
              const facebookFromNote = this.extractUrlFromNote(
                note,
                'Facebook',
              );

              this.company = {
                name: lsCompany.name,
                domain: lsCompany.www || null,
                phone: lsCompany.phone || lsCompany.cell || null,
                email: lsCompany.email || null,
                city: lsCompany.address_city || null,
                state: lsCompany.address_province_name || null,
                country: lsCompany.address_country_name || null,
                street: lsCompany.address_street || null,
                postcode: lsCompany.address_postcode || null,
                nip: lsCompany.nip || null,
                client_status: lsCompany.client_status || null,
                industry: null,
                linkedin: linkedinFromIM || linkedinFromNote || null,
                twitter: twitterFromIM || twitterFromNote || null,
                facebook: facebookFromIM || facebookFromNote || null,
                employees: null,
                id: lsCompany.id || null,
              };
            } else if (companyName) {
              // Only company_name available (flat string on the contact)
              this.company = {
                name: companyName,
                domain: null,
                phone: null,
                email: null,
                city: null,
                state: null,
                country: null,
                street: null,
                postcode: null,
                nip: null,
                client_status: null,
                industry: null,
                linkedin: null,
                twitter: null,
                facebook: null,
                employees: null,
              };
            } else {
              this.company = null;
            }

            this.isLoadedContact = true;
            this.isLoadedCompany = true;

            // Fetch deals for this contact
            this.getLivespaceDeals();
          }

          if (successSub) successSub.unsubscribe();
        },
        error: () => {
          this.isLoadedContact = true;
          this.isLoadedCompany = true;
          this.isLoadedDeals = true;
          if (successSub) successSub.unsubscribe();
        },
      });

    failureSub = getLivespaceContactFailure$
      .pipe(
        filter((failure) => failure !== null),
        take(1),
      )
      .subscribe({
        next: () => {
          this.contact = null;
          this.isLoadedContact = true;
          this.isLoadedCompany = true;
          this.isLoadedDeals = true;
          if (failureSub) failureSub.unsubscribe();
        },
        error: () => {
          if (failureSub) failureSub.unsubscribe();
        },
      });
  }

  /**
   * Fetch deals from Livespace for the current contact/company.
   */
  getLivespaceDeals(): void {
    const contactId = this.contact_id || undefined;
    const companyId = this.company?.id || undefined;

    if (!contactId && !companyId) {
      this.deals = [];
      this.isLoadedDeals = true;
      this.show_more_deals = false;
      return;
    }

    this.store
      .select(selectLivespaceDealsSuccess)
      .pipe(
        filter((data) => data != null),
        take(1),
      )
      .subscribe({
        next: (dealsData) => {
          // Livespace returns: { deal: [{...}, {...}] } or flat array
          let dealsList: any[] = [];
          if (Array.isArray(dealsData)) {
            dealsList = dealsData;
          } else if (dealsData?.deal && Array.isArray(dealsData.deal)) {
            dealsList = dealsData.deal;
          }

          // Map to display format matching template expectations
          this.deals = dealsList.map((d: any) => ({
            dealname: d.name,
            dealstage: d.stage_name || d.status || 'open',
            date_end: d.date_end,
            id: d.id || d.deal_id,
            pipeline: d.process_name,
          }));

          this.show_more_deals = false;
          this.isLoadedDeals = true;
        },
        error: () => {
          this.deals = [];
          this.show_more_deals = false;
          this.isLoadedDeals = true;
        },
      });

    this.store.dispatch(
      LivespaceActions.getLivespaceDeals({
        contact_id: contactId,
        company_id: companyId,
      }),
    );
  }

  /**
   * Collect company details from the active report's enriched data, sent
   * alongside contact creation so a newly-created Livespace company is fully
   * populated (not just its name). Only fields that exist are included.
   */
  private buildReportCompanyDetails(): {
    domain?: string;
    phone?: string;
    email?: string;
    city?: string;
    state?: string;
    country?: string;
    street?: string;
    postcode?: string;
    linkedin?: string;
    twitter?: string;
    facebook?: string;
  } {
    const enriched: any = this.getActiveCompany()?.enhanced_data ?? null;
    const details: any = {};
    const domain = enriched?.primary_domain || this.hs_company_domain;
    if (domain) details.domain = domain;
    const phone = enriched?.phone || this.hs_company_phone;
    if (phone) details.phone = phone;
    if (enriched?.email) details.email = enriched.email;
    const city = enriched?.city || this.hs_company_city;
    if (city) details.city = city;
    const state = enriched?.state || this.hs_company_state;
    if (state) details.state = state;
    if (enriched?.country) details.country = enriched.country;
    const street = enriched?.street_address || enriched?.street;
    if (street) details.street = street;
    const postcode = enriched?.postal_code || enriched?.postcode;
    if (postcode) details.postcode = postcode;
    if (enriched?.linkedin_url) details.linkedin = enriched.linkedin_url;
    if (enriched?.twitter_url) details.twitter = enriched.twitter_url;
    if (enriched?.facebook_url) details.facebook = enriched.facebook_url;
    return details;
  }

  /**
   * Normalize a raw Livespace company object (as returned by Contact/get or
   * addCompany) into the flat shape used by the company tab and forms.
   */
  private mapLivespaceCompany(lsCompany: any): any {
    const ims = lsCompany?.instant_messengers || [];
    const linkedinFromIM = this.extractFromInstantMessengers(ims, 6);
    const facebookFromIM = this.extractFromInstantMessengers(ims, 5);
    const twitterFromIM = this.extractFromInstantMessengers(ims, 9);

    const note = lsCompany?.note || '';
    const linkedinFromNote = this.extractUrlFromNote(note, 'LinkedIn');
    const twitterFromNote = this.extractUrlFromNote(note, 'Twitter');
    const facebookFromNote = this.extractUrlFromNote(note, 'Facebook');

    const phones = lsCompany?.phones || [];
    const emails = lsCompany?.emails || [];
    const addresses = lsCompany?.addresses || [];
    const firstAddress = addresses[0] || {};
    const firstPhone =
      typeof phones[0] === 'string' ? phones[0] : phones[0]?.phone_no ?? null;
    const firstEmail =
      typeof emails[0] === 'string' ? emails[0] : emails[0]?.email ?? null;

    return {
      name: lsCompany?.name || '',
      domain: lsCompany?.www || null,
      phone: lsCompany?.phone || lsCompany?.cell || firstPhone || null,
      email: lsCompany?.email || firstEmail || null,
      city: lsCompany?.address_city || firstAddress.city || null,
      state: lsCompany?.address_province_name || firstAddress.province || null,
      country: lsCompany?.address_country_name || firstAddress.country || null,
      street: lsCompany?.address_street || firstAddress.street || null,
      postcode: lsCompany?.address_postcode || firstAddress.postcode || null,
      nip: lsCompany?.nip || null,
      client_status: lsCompany?.client_status || null,
      industry: null,
      linkedin: linkedinFromIM || linkedinFromNote || null,
      twitter: twitterFromIM || twitterFromNote || null,
      facebook: facebookFromIM || facebookFromNote || null,
      employees: null,
      id: lsCompany?.id || null,
    };
  }

  newLivespaceContact(): void {
    if (!this.contactForm.valid) return;

    const allEmails = this.ls_email_inputs.filter((e) => e && e.trim() !== '');
    if (allEmails.length === 0) return;

    const allPhones = this.ls_phone_inputs.filter((p) => p && p.trim() !== '');

    const nameParts = (this.contactForm.value.hs_name || '').split(' ');
    const firstName = nameParts[0] || '';
    const lastName = nameParts.slice(1).join(' ') || '';

    const primaryEmail = allEmails[0];
    const primaryPhone = allPhones[0] || '';

    const socialMedia: {
      linkedin?: string;
      twitter?: string;
      facebook?: string;
    } = {};
    if (this.ls_linkedin) socialMedia.linkedin = this.ls_linkedin;
    if (this.ls_twitter) socialMedia.twitter = this.ls_twitter;
    if (this.ls_facebook) socialMedia.facebook = this.ls_facebook;

    this.isSubmittingContact = true;

    this.store.dispatch(
      LivespaceActions.livespaceNewContact({
        user_id: this.user.id,
        first_name: firstName,
        last_name: lastName,
        email: primaryEmail,
        phone: primaryPhone,
        emails: allEmails,
        phones: allPhones,
        company_name: this.hs_company_name || '',
        job_title: '',
        social_media:
          Object.keys(socialMedia).length > 0 ? socialMedia : undefined,
        company_details: this.buildReportCompanyDetails(),
      }),
    );

    const success$ = this.store.select(selectLivespaceNewContactSuccess);
    const failure$ = this.store.select(selectLivespaceNewContactFailure);

    let successSub: Subscription = null;
    let failureSub: Subscription = null;

    successSub = success$
      .pipe(
        filter((data) => data.livespace_new_contact != null),
        take(1),
      )
      .subscribe({
        next: (data) => {
          this.isSubmittingContact = false;

          // The backend links the contact to a company that now always exists
          // in Livespace: either matched by name (linked, not overwritten) or
          // auto-created with the full report details. Populate the company tab
          // and open the company form in UPDATE mode, so submitting it edits
          // that company instead of creating a duplicate.
          const payload: any = data.livespace_new_contact || {};
          const lsCompany = payload.company || null;
          const companyExisted = payload.company_existed === true;

          if (lsCompany) {
            this.company = this.mapLivespaceCompany(lsCompany);
            this.isLoadedCompany = true;
            this.activeCompanyId = this.company.id;
            this.isEditingCompany = true;

            this.companyForm.patchValue({
              hs_company_name: this.company.name || '',
              hs_company_domain: this.company.domain || '',
              hs_company_phone: this.company.phone || '',
              hs_company_city: this.company.city || '',
              hs_company_state: this.company.state || '',
            });
            this.ls_company_linkedin = this.company.linkedin || '';
            this.ls_company_twitter = this.company.twitter || '';
            this.ls_company_facebook = this.company.facebook || '';
          }

          this.popupService.notify(
            companyExisted
              ? 'Contact created and linked to the existing company. Review and update the company details if needed.'
              : 'Contact and company created in Livespace. Review the company details and update if needed.',
            'Livespace',
            'success',
          );

          // Reload contact data in the background so the contact tab is fresh.
          this.isLoadedContact = false;
          this.isLoadedDeals = false;
          this.getLivespaceContact();

          // Go to the company form (in update mode when a company was resolved).
          this.changeSidebarTab(5);

          if (successSub) successSub.unsubscribe();
        },
        error: (error) => {
          this.isSubmittingContact = false;
          console.error('Livespace New Contact error:', error);
          if (successSub) successSub.unsubscribe();
        },
      });

    failureSub = failure$
      .pipe(
        filter((failure) => failure !== null),
        take(1),
      )
      .subscribe({
        next: (error) => {
          this.isSubmittingContact = false;
          this.popupService.notify(
            error || 'Failed to create contact in Livespace',
            'Livespace Error',
            'error',
          );
          if (failureSub) failureSub.unsubscribe();
        },
        error: () => {
          this.isSubmittingContact = false;
          if (failureSub) failureSub.unsubscribe();
        },
      });
  }

  newLivespaceCompany(): void {
    if (!this.companyForm.valid) return;

    this.isSubmittingCompany = true;

    this.store.dispatch(
      LivespaceActions.livespaceNewCompany({
        user_id: this.user.id,
        company_name: this.companyForm.value.hs_company_name || '',
        company_domain: this.companyForm.value.hs_company_domain || '',
        company_phone: this.companyForm.value.hs_company_phone || '',
        company_city: this.companyForm.value.hs_company_city || '',
        company_state: this.companyForm.value.hs_company_state || '',
        company_linkedin: this.ls_company_linkedin || '',
        company_twitter: this.ls_company_twitter || '',
        company_facebook: this.ls_company_facebook || '',
      }),
    );

    const success$ = this.store.select(selectLivespaceNewCompanySuccess);
    const failure$ = this.store.select(selectLivespaceNewCompanyFailure);

    success$
      .pipe(
        filter((data) => data.livespace_new_company != null),
        take(1),
      )
      .subscribe({
        next: (data) => {
          this.isSubmittingCompany = false;
          this.popupService.notify(
            'Company created in Livespace!',
            'Livespace',
            'success',
          );
          this.createCompanyFromReport = false;
          this.isEditingCompany = false;

          // Populate company tab from response + form values as fallback.
          // Note: Livespace addCompany only echoes back sent fields + id,
          // NOT the full denormalized company object.
          const lsCompany = data.livespace_new_company;
          const formValues = this.companyForm.value;

          // Extract social links from instant_messengers array if present
          const ims = lsCompany.instant_messengers || [];
          const linkedinFromIM = this.extractFromInstantMessengers(ims, 6);
          const facebookFromIM = this.extractFromInstantMessengers(ims, 5);
          const twitterFromIM = this.extractFromInstantMessengers(ims, 9);

          // Extract from nested arrays (response echoes these back)
          const phones = lsCompany.phones || [];
          const emails = lsCompany.emails || [];
          const addresses = lsCompany.addresses || [];
          const firstAddress = addresses[0] || {};
          // phones can be ["111222333"] or [{phone_no: "..."}]
          const firstPhone =
            typeof phones[0] === 'string'
              ? phones[0]
              : phones[0]?.phone_no ?? null;
          const firstEmail =
            typeof emails[0] === 'string'
              ? emails[0]
              : emails[0]?.email ?? null;

          this.company = {
            name: lsCompany.name || formValues.hs_company_name || '',
            domain: lsCompany.www || formValues.hs_company_domain || null,
            phone:
              lsCompany.phone || firstPhone || formValues.hs_company_phone || null,
            email: lsCompany.email || firstEmail || null,
            city:
              lsCompany.address_city ||
              firstAddress.city ||
              formValues.hs_company_city ||
              null,
            state:
              lsCompany.address_province_name ||
              firstAddress.province ||
              formValues.hs_company_state ||
              null,
            country:
              lsCompany.address_country_name ||
              firstAddress.country ||
              null,
            street:
              lsCompany.address_street || firstAddress.street || null,
            postcode:
              lsCompany.address_postcode ||
              firstAddress.postcode ||
              null,
            nip: lsCompany.nip || null,
            client_status: lsCompany.client_status || null,
            industry: null,
            linkedin:
              linkedinFromIM || this.ls_company_linkedin || null,
            twitter:
              twitterFromIM || this.ls_company_twitter || null,
            facebook:
              facebookFromIM || this.ls_company_facebook || null,
            employees: null,
            id: lsCompany.id || null,
          };

          this.isLoadedCompany = true;
          this.changeSidebarTab(1);
        },
      });

    failure$
      .pipe(
        filter((err) => err !== null),
        take(1),
      )
      .subscribe({
        next: (error) => {
          this.isSubmittingCompany = false;
          this.popupService.notify(
            error || 'Failed to create company in Livespace',
            'Livespace Error',
            'error',
          );
        },
      });
  }

  /**
   * Update an existing company in Livespace.
   */
  updateLivespaceCompany(): void {
    if (!this.companyForm.valid || !this.company?.id) return;

    this.isSubmittingCompany = true;

    this.store.dispatch(
      LivespaceActions.livespaceUpdateCompany({
        user_id: this.user.id,
        company_id: this.company.id,
        company_name: this.companyForm.value.hs_company_name || '',
        company_domain: this.companyForm.value.hs_company_domain || '',
        company_phone: this.companyForm.value.hs_company_phone || '',
        company_city: this.companyForm.value.hs_company_city || '',
        company_state: this.companyForm.value.hs_company_state || '',
        company_linkedin: this.ls_company_linkedin || '',
        company_twitter: this.ls_company_twitter || '',
        company_facebook: this.ls_company_facebook || '',
      }),
    );

    const success$ = this.store.select(selectLivespaceNewCompanySuccess);
    const failure$ = this.store.select(selectLivespaceNewCompanyFailure);

    success$
      .pipe(
        filter((data) => data.livespace_new_company != null),
        take(1),
      )
      .subscribe({
        next: (data) => {
          this.isSubmittingCompany = false;
          this.popupService.notify(
            'Company updated in Livespace!',
            'Livespace',
            'success',
          );
          this.isEditingCompany = false;

          // Populate company tab from update response + form values as fallback.
          // Note: Livespace editCompany only echoes back modified fields + id.
          const lsCompany = data.livespace_new_company;
          const formValues = this.companyForm.value;

          // Extract social links from instant_messengers array if present
          const ims = lsCompany.instant_messengers || [];
          const linkedinFromIM = this.extractFromInstantMessengers(ims, 6);
          const facebookFromIM = this.extractFromInstantMessengers(ims, 5);
          const twitterFromIM = this.extractFromInstantMessengers(ims, 9);

          // Extract from nested arrays (response echoes these back)
          const phones = lsCompany.phones || [];
          const emails = lsCompany.emails || [];
          const addresses = lsCompany.addresses || [];
          const firstAddress = addresses[0] || {};
          const firstPhone =
            typeof phones[0] === 'string'
              ? phones[0]
              : phones[0]?.phone_no ?? null;
          const firstEmail =
            typeof emails[0] === 'string'
              ? emails[0]
              : emails[0]?.email ?? null;

          this.company = {
            name: lsCompany.name || formValues.hs_company_name || '',
            domain: lsCompany.www || formValues.hs_company_domain || null,
            phone:
              lsCompany.phone || firstPhone || formValues.hs_company_phone || null,
            email: lsCompany.email || firstEmail || null,
            city:
              lsCompany.address_city ||
              firstAddress.city ||
              formValues.hs_company_city ||
              null,
            state:
              lsCompany.address_province_name ||
              firstAddress.province ||
              formValues.hs_company_state ||
              null,
            country:
              lsCompany.address_country_name ||
              firstAddress.country ||
              null,
            street:
              lsCompany.address_street || firstAddress.street || null,
            postcode:
              lsCompany.address_postcode ||
              firstAddress.postcode ||
              null,
            nip: lsCompany.nip || null,
            client_status: lsCompany.client_status || null,
            industry: null,
            linkedin:
              linkedinFromIM || this.ls_company_linkedin || null,
            twitter:
              twitterFromIM || this.ls_company_twitter || null,
            facebook:
              facebookFromIM || this.ls_company_facebook || null,
            employees: null,
            id: lsCompany.id || this.company?.id || null,
          };

          this.isLoadedCompany = true;
          this.changeSidebarTab(1);
        },
      });

    failure$
      .pipe(
        filter((err) => err !== null),
        take(1),
      )
      .subscribe({
        next: (error) => {
          this.isSubmittingCompany = false;
          this.popupService.notify(
            error || 'Failed to update company in Livespace',
            'Livespace Error',
            'error',
          );
        },
      });
  }

  /**
   * Open the contact form pre-filled with existing Livespace contact data for editing.
   */
  editLivespaceContact(): void {
    this.isEditingContact = true;

    // Pre-fill form from existing Livespace contact
    const fullName = (
      (this.contact?.firstname || '') +
      ' ' +
      (this.contact?.lastname || '')
    ).trim();
    const email = this.contact?.email || this.hs_mail || '';
    const phone =
      this.contact?.phone || this.contact?.cell || this.hs_phone || '';

    this.contactForm.patchValue({
      hs_name: fullName,
      hs_mail: email,
      hs_phone: phone,
      hs_brief: this.contact?.note || '',
    });

    // Re-build email/phone lists from the existing contact for multi-value display
    this.buildLivespaceContactLists();

    // Pre-fill social media from instant_messengers
    const ims = this.contact?.instant_messengers || [];
    this.ls_linkedin =
      this.extractFromInstantMessengers(ims, 6) || this.ls_linkedin || '';
    this.ls_twitter =
      this.extractFromInstantMessengers(ims, 9) || this.ls_twitter || '';
    this.ls_facebook =
      this.extractFromInstantMessengers(ims, 5) || this.ls_facebook || '';

    this.changeSidebarTab(4);
  }

  /**
   * Update an existing contact in Livespace (uses editContact endpoint).
   */
  updateLivespaceContact(): void {
    if (!this.contactForm.valid || !this.contact_id) return;

    const nameParts = (this.contactForm.value.hs_name || '').split(' ');
    const firstName = nameParts[0] || '';
    const lastName = nameParts.slice(1).join(' ') || '';

    const primaryEmail = this.contactForm.value.hs_mail || '';
    const extraEmails = this.ls_selected_emails.filter(
      (e) => e !== primaryEmail,
    );
    const allEmails = [primaryEmail, ...extraEmails].filter(Boolean);

    const primaryPhone = this.contactForm.value.hs_phone || '';
    const extraPhones = this.ls_selected_phones.filter(
      (p) => p !== primaryPhone,
    );
    const allPhones = [primaryPhone, ...extraPhones].filter(Boolean);

    const socialMedia: {
      linkedin?: string;
      twitter?: string;
      facebook?: string;
    } = {};
    if (this.ls_linkedin) socialMedia.linkedin = this.ls_linkedin;
    if (this.ls_twitter) socialMedia.twitter = this.ls_twitter;
    if (this.ls_facebook) socialMedia.facebook = this.ls_facebook;

    this.isSubmittingContact = true;

    this.store.dispatch(
      LivespaceActions.livespaceUpdateContact({
        user_id: this.user.id,
        contact_id: this.contact_id,
        first_name: firstName,
        last_name: lastName,
        email: primaryEmail,
        phone: primaryPhone,
        emails: allEmails,
        phones: allPhones,
        company_name: this.hs_company_name || '',
        job_title: this.contact?.role || '',
        social_media:
          Object.keys(socialMedia).length > 0 ? socialMedia : undefined,
      }),
    );

    const success$ = this.store.select(selectLivespaceNewContactSuccess);
    const failure$ = this.store.select(selectLivespaceNewContactFailure);

    success$
      .pipe(
        filter((data) => data.livespace_contact != null),
        take(1),
      )
      .subscribe({
        next: () => {
          this.isSubmittingContact = false;
          this.popupService.notify(
            'Contact updated in Livespace!',
            'Livespace',
            'success',
          );
          this.isEditingContact = false;
          this.isLoadedContact = false;
          this.isLoadedCompany = false;
          this.isLoadedDeals = false;
          this.getLivespaceContact();
          this.changeSidebarTab(0);
        },
      });

    failure$
      .pipe(
        filter((f) => f !== null),
        take(1),
      )
      .subscribe({
        next: (error) => {
          this.isSubmittingContact = false;
          this.popupService.notify(
            error || 'Failed to update contact in Livespace',
            'Livespace Error',
            'error',
          );
        },
      });
  }
}
